import { render, staticRenderFns } from "./Tooltip.component.vue?vue&type=template&id=2fcd9752&scoped=true&lang=pug"
import script from "./Tooltip.component.vue?vue&type=script&lang=ts"
export * from "./Tooltip.component.vue?vue&type=script&lang=ts"
import style0 from "./Tooltip.component.vue?vue&type=style&index=0&id=2fcd9752&prod&lang=scss"
import style1 from "./Tooltip.component.vue?vue&type=style&index=1&id=2fcd9752&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd9752",
  null
  
)

export default component.exports